import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const ChbkLedgerLineList = ({ chbkLedgerObj: chbkLedger }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!chbkLedger) return;

      rowsReq.partition = chbkLedger.partition;
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('chbkLedgerId', chbkLedger.id));
    },
    [chbkLedger?.partition, chbkLedger?.id, chbkLedger?.rcvdPeriodId],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Ledger Lines come from system only
  };

  return <EntityList entity="CHBK_LEDGER_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
